import type { ReactNode } from 'react';

export const symbol_fit_page_width: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm680-580H140v520h680v-520Zm-680 0v520-520Zm196 320v-120q0-9.92-9.5-13.46Q317-557 310-550l-49 49q-9 9-9 21t9 21l49 49q7 7 16.5 3.46T336-420Zm363-81-49-49q-7-7-16.5-3.46T624-540v120q0 9.92 9.5 13.46Q643-403 650-410l49-49q9-9 9-21t-9-21Z"
		/>
	</svg>
);
